import { render, staticRenderFns } from "./VictimsQuestionModal.vue?vue&type=template&id=42e55f47&scoped=true&"
import script from "./VictimsQuestionModal.vue?vue&type=script&lang=js&"
export * from "./VictimsQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./VictimsQuestionModal.vue?vue&type=style&index=0&id=42e55f47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e55f47",
  null
  
)

export default component.exports